import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TPostContentPhotoGallerySet, EPostContentPhotoGalleryActionType } from './types';
import { IPostContentPhotoGallery } from '../../types/postContentPhotoGalleries';

export const setPostContentPhotoGallery: (data: IPostContentPhotoGallery) => TPostContentPhotoGallerySet =
  actionGenerator<EPostContentPhotoGalleryActionType.Set, IPostContentPhotoGallery>(
    EPostContentPhotoGalleryActionType.Set,
  );
